// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1544": "5f89df48b045","3616": "2bd20f1d2224","8942": "f06e52cc1430",}[chunkId] + ".css"
}